// // import { useEffect, useState, useMemo } from "react";

// // import { useParams, Link, useNavigate } from "react-router-dom";

// // import api from "../../api/axiosInstance";

// // import { Helmet } from "react-helmet-async";

// // import ReactMarkdown from "react-markdown";

// // import remarkGfm from "remark-gfm";

// // import rehypeSlug from "rehype-slug";

// // import rehypeAutolinkHeadings from "rehype-autolink-headings";



// // import NavigationTabBar from "../../components/navigation/NavigationTabBar";

// // import FooterSection from "../../components/navigation/FooterSection";

// // import Icon from "../../components/AppIcon";



// // /* ================= Skeleton ================= */

// // const Skeleton = () => (

// //   <div className="max-w-3xl mx-auto pt-32 px-4 animate-pulse">

// //     <div className="h-10 bg-muted rounded mb-6" />

// //     <div className="h-4 bg-muted rounded w-1/3 mb-10" />

// //     <div className="h-[360px] bg-muted rounded-xl mb-10" />

// //     <div className="space-y-4">

// //       <div className="h-4 bg-muted rounded" />

// //       <div className="h-4 bg-muted rounded" />

// //       <div className="h-4 bg-muted rounded w-2/3" />

// //     </div>

// //   </div>

// // );



// // export default function BlogDetail() {

// //   const { slug } = useParams();
// //   const navigate = useNavigate();

// //   const [data, setData] = useState(null);

// //   const [relativeTime, setRelativeTime] = useState('');

// //   const [isLoaded, setIsLoaded] = useState(false);

// //   const [isLiked, setIsLiked] = useState(false);

// //   const [likesCount, setLikesCount] = useState(0);



// //   /* ================= Fetch ================= */

// //   useEffect(() => {

// //     api.get(`/api/blogs/slug/${slug}`).then((res) => {

// //       setData(res.data.data);

// //       setIsLiked(false); // Initialize as not liked

// //       setLikesCount(res.data.data.blog?.likes || 0);

// //       setIsLoaded(true);

// //     });

// //   }, [slug]);



// //   /* ================= DYNAMIC RELATIVE TIME ================= */

// //   const getRelativeTime = (dateString) => {

// //     const now = new Date();

// //     const past = new Date(dateString);

// //     const seconds = Math.floor((now - past) / 1000);



// //     const intervals = {

// //       year: 31536000,

// //       month: 2592000,

// //       day: 86400,

// //       hour: 3600,

// //       minute: 60

// //     };



// //     for (let key in intervals) {

// //       const value = Math.floor(seconds / intervals[key]);

// //       if (value >= 1) {

// //         return value + " " + key + (value > 1 ? "s" : "") + " ago";

// //       }

// //     }



// //     return "Just now";

// //   };



// //   // Update relative time every minute

// //   useEffect(() => {

// //     if (data?.blog?.publishedAt) {

// //       setRelativeTime(getRelativeTime(data.blog.publishedAt));

      

// //       const interval = setInterval(() => {

// //         setRelativeTime(getRelativeTime(data.blog.publishedAt));

// //       }, 60000);

// //       return () => clearInterval(interval);

// //     }

// //   }, [data?.blog?.publishedAt]);



// //   /* ================= TOC (SAFE HOOK ORDER) ================= */

// //   const headings = useMemo(() => {

// //     if (!data?.blog?.content) return [];



// //     const regex = /^(##|###)\s+(.*)$/gm;

// //     const items = [];

// //     let match;



// //     while ((match = regex.exec(data.blog.content)) !== null) {

// //       items.push({

// //         level: match[1].length,

// //         text: match[2],

// //         id: match[2].toLowerCase().replace(/[^\w]+/g, "-"),

// //       });

// //     }

// //     return items;

// //   }, [data]);



// //   if (!data) return <Skeleton />;



// //   const { blog, related = [] } = data;



// //   // Get exact date for tooltip

// //   const getExactDate = (dateString) => {

// //     const date = new Date(dateString);

// //     const options = { 

// //       year: 'numeric', 

// //       month: 'long', 

// //       day: 'numeric',

// //       hour: '2-digit',

// //       minute: '2-digit'

// //     };

// //     return date.toLocaleDateString('en-US', options);

// //   };



// //   // Calculate read time

// //   const calculateReadTime = (content) => {

// //     if (!content) return '1 min read';

// //     const words = content.split(' ').length;

// //     const minutes = Math.ceil(words / 200);

// //     return `${minutes} min read`;

// //   };



// //   return (

// //     <>

// //       {/* ================= CSS ANIMATIONS ================= */}

// //       <style jsx>{`

// //         @keyframes fadeIn {

// //           from {

// //             opacity: 0;

// //             transform: translateY(20px);

// //           }

// //           to {

// //             opacity: 1;

// //             transform: translateY(0);

// //           }

// //         }

        

// //         .animate-fade-in {

// //           animation: fadeIn 0.6s ease-out;

// //         }

// //       `}</style>

      

// //       {/* ================= SEO ================= */}

// //       <Helmet>

// //         <title>{blog.seo?.metaTitle || blog.title}</title>

// //         <meta

// //           name="description"

// //           content={blog.seo?.metaDescription || blog.excerpt}

// //         />

// //         <meta

// //           name="keywords"

// //           content={blog.social?.hashtags?.join(", ")}

// //         />

// //         <meta property="og:title" content={blog.title} />

// //         <meta property="og:description" content={blog.excerpt} />

// //         <meta property="og:image" content={blog.coverImage} />

// //       </Helmet>



// //       <NavigationTabBar />



// //       {/* ================= MAIN CONTENT WITH BACKGROUND ================= */}

// //         <div className={`min-h-screen bg-gray-50 ${isLoaded ? 'animate-fade-in' : ''}`}>

// //           {/* ================= BACK BUTTON ================= */}

// //           <div className="max-w-4xl mx-auto px-4 pt-24">

// //             <div 
// //               onClick={() => {
// //                 console.log('Back button clicked!');
// //                 navigate('/blog-content-hub');
// //               }}
// //               className="inline-flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-all duration-200 mb-6 z-10 relative bg-white px-4 py-2 rounded-lg shadow-md hover:shadow-lg hover:bg-gray-50 cursor-pointer"
// //               style={{ 
// //                 pointerEvents: 'auto',
// //                 width: 'fit-content',
// //                 display: 'inline-flex'
// //               }}
// //             >
// //               <span className="text-lg pointer-events-none">←</span>
// //               <span className="text-sm font-medium pointer-events-none">Back to Blogs</span>
// //             </div>

// //           </div>



// //           {/* ================= BLOG CONTENT (NO CARD WRAPPER) ================= */}

// //           <div className="max-w-4xl mx-auto px-4 pb-32">

            

// //             {/* ================= CATEGORY BADGE ================= */}

// //             {blog.category?.name && (

// //               <div className="mb-4">

// //                 <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-indigo-100 text-indigo-700">

// //                   {blog.category.name.toUpperCase()}

// //                 </span>

// //               </div>

// //             )}



// //             {/* ================= HERO SECTION ================= */}

// //             <header className="text-center mb-6">

// //               <h1 className="text-4xl md:text-[46px] font-bold leading-[1.2] mb-3 mx-auto text-gray-900 max-w-[800px]" 

// //                   style={{ letterSpacing: '-0.5px', fontWeight: '700' }}>

// //                 {blog.title}

// //               </h1>

              

// //               {/* ================= META INFO ================= */}

// //               <div className="flex items-center justify-center gap-4 mt-3 mb-8">

// //                 <span 

// //                   className="hover:text-gray-900 transition-colors cursor-help text-[14px] text-gray-500" 

// //                   style={{ color: '#6B7280' }}

// //                   title={getExactDate(blog.publishedAt)}

// //                 >

// //                   {relativeTime}

// //                 </span>

// //                 <span className="w-1 h-1 bg-gray-300 rounded-full"></span>

// //                 <span className="text-[14px] text-gray-500" style={{ color: '#6B7280' }}>

// //                   {blog.views || 0} views

// //                 </span>

// //               </div>

// //             </header>



// //             {/* ================= COVER IMAGE ================= */}

// //             {blog.coverImage && (

// //               <div className="mb-8">

// //                 <div className="relative overflow-hidden rounded-[20px] shadow-lg transition-transform duration-300 hover:scale-[1.02] max-w-3xl mx-auto"

// //                      style={{ boxShadow: '0 15px 40px rgba(0,0,0,0.08)', borderBottom: '1px solid #E5E7EB' }}>

// //                   <img

// //                     src={blog.coverImage}

// //                     alt={blog.title}

// //                     className="w-full h-auto object-cover max-w-1xl mx-auto block"

// //                     style={{ aspectRatio: '16/9' }}

// //                   />

// //                   {/* Subtle gradient overlay for premium feel */}

// //                   <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent pointer-events-none"></div>

// //                 </div>

// //               </div>

// //             )}

// //             {/* ================= 3-COLUMN METADATA SECTION ================= */}

// //             <div className="mt-6 grid grid-cols-3 bg-gray-50 rounded-xl border border-gray-200/50 overflow-hidden mb-12 py-3">
// //               {/* CATEGORY COLUMN */}

// //               <div className="flex flex-col items-center justify-center text-center border-r border-gray-200/50 last:border-r-0 hover:bg-gray-100 transition-all duration-200">

// //                 <div className="text-xs uppercase tracking-wider text-gray-400 font-medium">

// //                   CATEGORY

// //                 </div>

// //                 <div className="mt-1 text-base font-semibold text-gray-800">

// //                   {blog.category?.name || 'General'}

// //                 </div>

// //               </div>

// //               {/* READ TIME COLUMN */}

// //               <div className="flex flex-col items-center justify-center text-center border-r border-gray-200/50 last:border-r-0 hover:bg-gray-100 transition-all duration-200">

// //                 <div className="text-xs uppercase tracking-wider text-gray-400 font-medium">

// //                   READ TIME

// //                 </div>

// //                 <div className="mt-1 text-base font-semibold text-gray-800">

// //                   {calculateReadTime(blog.content)}

// //                 </div>

// //               </div>

// //               {/* DATE COLUMN */}

// //               <div className="flex flex-col items-center justify-center text-center border-r border-gray-200/50 last:border-r-0 hover:bg-gray-100 transition-all duration-200">

// //                 <div className="text-xs uppercase tracking-wider text-gray-400 font-medium">

// //                   DATE

// //                 </div>

// //                 <div className="mt-1 text-base font-semibold text-gray-800">

// //                   {new Date(blog.publishedAt).toLocaleDateString("en-US", {

// //                     year: "numeric",

// //                     month: "short",

// //                     day: "numeric"

// //                   })}

// //                 </div>

// //               </div>

// //             </div>



// //             {/* ================= CONTENT ================= */}

// //             <article className="prose prose-lg max-w-none mb-12 mt-10" 

// //                      style={{ 

// //                        lineHeight: '1.8', 

// //                        fontSize: '18px',

// //                        color: '#374151'

// //                      }}>

// //               <ReactMarkdown

// //                 remarkPlugins={[remarkGfm]}

// //                 rehypePlugins={[

// //                   rehypeSlug,

// //                   [rehypeAutolinkHeadings, { behavior: "wrap" }],

// //                 ]}

// //               >

// //                 {blog.content}

// //               </ReactMarkdown>

// //             </article>

// //             {/* ================= AUTHOR SECTION ================= */}

// //             <div className="mb-4 mt-12">
// //               <div className="border-t border-gray-200 pt-6">
// //                 <div className="flex items-center gap-4">
// //                   <div className="w-12 h-12 bg-gray-300 rounded-full flex items-center justify-center">
// //                     <span className="text-gray-600 font-semibold">
// //                       {blog.author?.name?.charAt(0)?.toUpperCase() || 'A'}
// //                     </span>
// //                   </div>
// //                   <div className="flex-1">
// //                     <h4 className="font-semibold text-gray-900 mb-1">
// //                       {blog.author?.name || 'Anonymous'}
// //                     </h4>
// //                     <p className="text-sm text-gray-600">
// //                       Published on {new Date(blog.publishedAt).toLocaleDateString("en-US", {
// //                         year: "numeric",
// //                         month: "long",
// //                         day: "numeric"
// //                       })}
// //                     </p>
// //                   </div>
// //                   <button 
// //                     onClick={() => {
// //                       setIsLiked(!isLiked);
// //                       setLikesCount(isLiked ? likesCount - 1 : likesCount + 1);
// //                       console.log('Like button clicked, isLiked:', !isLiked);
// //                     }}
// //                     className="flex items-center gap-2 px-4 py-2 bg-white text-red-500 border border-red-500 rounded-lg hover:bg-red-50 transition-colors"
// //                   >
// //                     <Icon 
// //                       name="Heart" 
// //                       size={16} 
// //                       className={isLiked ? 'text-red-500 fill-red-500' : 'text-red-500'}
// //                     />
// //                     <span>Like</span>
// //                   </button>
// //                 </div>
// //               </div>
// //             </div>


// //             {/* ================= TAGS ================= */}

// //             {blog.social?.hashtags?.length > 0 && (

// //               <div className="mb-8">

// //                 <div className="border-t border-gray-200 pt-6 mb-4">

// //                   <h3 className="text-lg font-semibold text-gray-900 mb-3">Tags</h3>

// //                   <div className="flex flex-wrap gap-2">

// //                     {blog.social.hashtags.map((tag, i) => (

// //                       <span

// //                         key={i}

// //                         className="px-3 py-1.5 rounded-full bg-indigo-50 text-indigo-700 text-sm font-medium hover:bg-indigo-100 transition-colors cursor-pointer"

// //                       >

// //                         #{tag}

// //                       </span>

// //                     ))}

// //                   </div>

// //                 </div>

// //               </div>

// //             )}



// //             {/* ================= SHARE ================= */}
// //             <div className="mb-12">
// //               <div className="flex items-center gap-4">
// //                 {blog.social?.linkedinPostUrl && (
// //                   <a 
// //                     href={blog.social.linkedinPostUrl} 
// //                     target="_blank"
// //                     className="p-2 rounded-lg bg-gray-100 hover:bg-gray-200 transition-colors"
// //                   >
// //                     <Icon name="Linkedin" size={20} />
// //                   </a>
// //                 )}
// //                 {blog.social?.instagramPostUrl && (
// //                   <a 
// //                     href={blog.social.instagramPostUrl} 
// //                     target="_blank"
// //                     className="p-2 rounded-lg bg-gray-100 hover:bg-gray-200 transition-colors"
// //                   >
// //                     <Icon name="Instagram" size={20} />
// //                   </a>
// //                 )}
// //                 {blog.social?.twitterPostUrl && (
// //                   <a 
// //                     href={blog.social.twitterPostUrl} 
// //                     target="_blank"
// //                     className="p-2 rounded-lg bg-gray-100 hover:bg-gray-200 transition-colors"
// //                   >
// //                     <Icon name="Twitter" size={20} />
// //                   </a>
// //                 )}
// //               </div>
// //             </div>



// //             {/* ================= RELATED ARTICLES ================= */}
// //             {related.length > 0 && (

// //               <section className="mt-16">

// //                 <div className="border-t border-gray-200 pt-8 mb-6">

// //                   <h3 className="text-2xl font-bold mb-6 text-gray-900">

// //                     Related Articles

// //                   </h3>

// //                 </div>

// //                 <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6">

// //                   {related.map((r) => (

// //                     <Link

// //                       key={r._id}

// //                       to={`/blog/${r.slug}`}

// //                       className="group rounded-xl border bg-white overflow-hidden hover:shadow-lg transition-all duration-300"

// //                     >

// //                       <div className="relative h-40 overflow-hidden">

// //                         <img

// //                           src={r.coverImage || 'https://placehold.co/300x200?text=Related'}

// //                           alt={r.title}

// //                           className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"

// //                         />

// //                         <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>

// //                       </div>

// //                       <div className="p-4">

// //                         <h4 className="font-semibold text-gray-900 mb-2 line-clamp-2 group-hover:text-indigo-600 transition-colors">

// //                           {r.title}

// //                         </h4>

// //                         <p className="text-sm text-gray-600 line-clamp-3">

// //                           {r.excerpt}

// //                         </p>

// //                       </div>

// //                     </Link>

// //                   ))}

// //                 </div>

// //               </section>

// //             )}

// //           </div>



// //           {/* ================= TOC (STICKY SIDEBAR) ================= */}

// //           {headings.length > 0 && (

// //             <aside className="hidden xl:block fixed right-8 top-32 w-64">

// //               <div className="bg-white rounded-lg shadow-md p-4">

// //                 <h4 className="text-sm font-semibold mb-3 text-gray-900">On this page</h4>

// //                 <ul className="space-y-2 text-sm">

// //                   {headings.map((h) => (

// //                     <li key={h.id} className={h.level === 3 ? "ml-4" : ""}>
// //                       <a
// //                         href={`#${h.id}`}
// //                         className="text-gray-600 hover:text-indigo-600 transition-colors"
// //                       >
// //                         {h.text}
// //                       </a>
// //                     </li>
                  

// //                   ))}

// //                 </ul>

// //               </div>

// //             </aside>

// //           )}

// //         </div>



// //       <FooterSection />

// //     </>

// //   );

// // }




// import { useEffect, useState, useMemo } from "react";
// import { useParams, Link, useNavigate } from "react-router-dom";
// import api from "../../api/axiosInstance";
// import { Helmet } from "react-helmet-async";
// import ReactMarkdown from "react-markdown";
// import remarkGfm from "remark-gfm";
// import rehypeSlug from "rehype-slug";
// import rehypeAutolinkHeadings from "rehype-autolink-headings";
// import rehypeHighlight from "rehype-highlight";

// import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
// import { atomDark } from "react-syntax-highlighter/dist/esm/styles/prism";

// import NavigationTabBar from "../../components/navigation/NavigationTabBar";
// import FooterSection from "../../components/navigation/FooterSection";
// import Icon from "../../components/AppIcon";

// const Skeleton = () => (
//   <div className="max-w-3xl mx-auto pt-32 px-4 animate-pulse">
//     <div className="h-10 bg-muted rounded mb-6" />
//     <div className="h-4 bg-muted rounded w-1/3 mb-10" />
//     <div className="h-[360px] bg-muted rounded-xl mb-10" />
//     <div className="space-y-4">
//       <div className="h-4 bg-muted rounded" />
//       <div className="h-4 bg-muted rounded" />
//       <div className="h-4 bg-muted rounded w-2/3" />
//     </div>
//   </div>
// );

// export default function BlogDetail() {

//   const { slug } = useParams();
//   const navigate = useNavigate();

//   const [data, setData] = useState(null);
//   const [relativeTime, setRelativeTime] = useState('');
//   const [readingProgress, setReadingProgress] = useState(0);

//   /* ================= Fetch Blog ================= */

//   useEffect(() => {
//     api.get(`/api/blogs/slug/${slug}`).then((res) => {
//       setData(res.data.data);
//     });
//   }, [slug]);

//   /* ================= Reading Progress ================= */

//   useEffect(() => {

//     const updateScrollProgress = () => {

//       const totalHeight =
//         document.documentElement.scrollHeight -
//         document.documentElement.clientHeight;

//       const scrollPosition = window.scrollY;

//       const progress = (scrollPosition / totalHeight) * 100;

//       setReadingProgress(progress);
//     };

//     window.addEventListener("scroll", updateScrollProgress);

//     return () => window.removeEventListener("scroll", updateScrollProgress);

//   }, []);

//   /* ================= Relative Time ================= */

//   const getRelativeTime = (dateString) => {

//     const now = new Date();
//     const past = new Date(dateString);
//     const seconds = Math.floor((now - past) / 1000);

//     const intervals = {
//       year: 31536000,
//       month: 2592000,
//       day: 86400,
//       hour: 3600,
//       minute: 60
//     };

//     for (let key in intervals) {

//       const value = Math.floor(seconds / intervals[key]);

//       if (value >= 1) {
//         return value + " " + key + (value > 1 ? "s" : "") + " ago";
//       }
//     }

//     return "Just now";
//   };

//   useEffect(() => {

//     if (data?.blog?.publishedAt) {
//       setRelativeTime(getRelativeTime(data.blog.publishedAt));
//     }

//   }, [data]);

//   /* ================= TOC ================= */

//   const headings = useMemo(() => {

//     if (!data?.blog?.content) return [];

//     const regex = /^(##|###)\s+(.*)$/gm;

//     const items = [];

//     let match;

//     while ((match = regex.exec(data.blog.content)) !== null) {

//       items.push({
//         level: match[1].length,
//         text: match[2],
//         id: match[2].toLowerCase().replace(/[^\w]+/g, "-"),
//       });
//     }

//     return items;

//   }, [data]);

//   if (!data) return <Skeleton />;

//   const { blog, related = [] } = data;

//   /* ================= Read Time ================= */

//   const calculateReadTime = (content) => {

//     if (!content) return '1 min read';

//     const words = content.split(' ').length;

//     const minutes = Math.ceil(words / 200);

//     return `${minutes} min read`;
//   };

//   return (

//     <>
//       <Helmet>
//         <title>{blog.title}</title>
//         <meta name="description" content={blog.excerpt} />
//       </Helmet>

//       <NavigationTabBar />

//       {/* ================= Reading Progress Bar ================= */}

//       <div
//         className="fixed top-0 left-0 h-1 bg-indigo-600 z-50"
//         style={{ width: `${readingProgress}%` }}
//       />

//       <div className="min-h-screen bg-gray-50">

//         {/* ================= Back Button ================= */}

//         <div className="max-w-4xl mx-auto px-4 pt-24">

//           <button
//             onClick={() => navigate('/blog-content-hub')}
//             className="flex items-center gap-2 text-gray-600 hover:text-gray-900"
//           >
//             ← Back to Blogs
//           </button>

//         </div>

//         <div className="max-w-4xl mx-auto px-4 pb-32">

//           {/* ================= TITLE ================= */}

//           <h1 className="text-4xl font-bold text-center mt-8 mb-4">
//             {blog.title}
//           </h1>

//           {/* ================= META ================= */}

//           <div className="flex justify-center gap-4 text-gray-500 mb-8">

//             <span>{relativeTime}</span>

//             <span>•</span>

//             <span>{blog.views || 0} views</span>

//             <span>•</span>

//             <span>{calculateReadTime(blog.content)}</span>

//           </div>

//           {/* ================= COVER IMAGE ================= */}

//           {blog.coverImage && (

//             <img
//               src={blog.coverImage}
//               alt={blog.title}
//               className="rounded-xl mb-10 w-full"
//             />

//           )}

//           {/* ================= BLOG CONTENT ================= */}

//           <article
//             className="prose prose-lg max-w-none
//             prose-headings:font-bold
//             prose-h2:text-3xl
//             prose-h3:text-2xl
//             prose-p:text-gray-700
//             prose-img:rounded-xl
//             prose-a:text-indigo-600"
//           >

//             <ReactMarkdown
//               remarkPlugins={[remarkGfm]}
//               rehypePlugins={[
//                 rehypeSlug,
//                 rehypeHighlight,
//                 [rehypeAutolinkHeadings, { behavior: "wrap" }],
//               ]}
//               components={{
//                 code({ node, inline, className, children, ...props }) {

//                   const match = /language-(\w+)/.exec(className || "");

//                   return !inline && match ? (

//                     <SyntaxHighlighter
//                       style={atomDark}
//                       language={match[1]}
//                       PreTag="div"
//                       {...props}
//                     >
//                       {String(children).replace(/\n$/, "")}
//                     </SyntaxHighlighter>

//                   ) : (

//                     <code className="bg-gray-100 px-1 py-0.5 rounded">

//                       {children}

//                     </code>
//                   );
//                 }
//               }}
//             >
//               {blog.content}
//             </ReactMarkdown>

//           </article>

//           {/* ================= RELATED ARTICLES ================= */}

//           {related.length > 0 && (

//             <section className="mt-20">

//               <h3 className="text-2xl font-bold mb-6">

//                 Related Articles

//               </h3>

//               <div className="grid md:grid-cols-3 gap-6">

//                 {related.map((r) => (

//                   <Link
//                     key={r._id}
//                     to={`/blog/${r.slug}`}
//                     className="border rounded-xl overflow-hidden hover:shadow-lg"
//                   >

//                     <img
//                       src={r.coverImage}
//                       alt={r.title}
//                       className="h-40 w-full object-cover"
//                     />

//                     <div className="p-4">

//                       <h4 className="font-semibold mb-2">

//                         {r.title}

//                       </h4>

//                       <p className="text-sm text-gray-600">

//                         {r.excerpt}

//                       </p>

//                     </div>

//                   </Link>

//                 ))}

//               </div>

//             </section>

//           )}

//         </div>

//         {/* ================= TOC ================= */}

//         {headings.length > 0 && (

//           <aside className="hidden xl:block fixed right-8 top-32 w-64">

//             <div className="bg-white rounded-lg shadow-md p-4">

//               <h4 className="font-semibold mb-3">

//                 On this page

//               </h4>

//               <ul className="space-y-2 text-sm">

//                 {headings.map((h) => (

//                   <li key={h.id} className={h.level === 3 ? "ml-4" : ""}>

//                     <a
//                       href={`#${h.id}`}
//                       className="text-gray-600 hover:text-indigo-600"
//                     >
//                       {h.text}
//                     </a>

//                   </li>

//                 ))}

//               </ul>

//             </div>

//           </aside>

//         )}

//       </div>

//       <FooterSection />

//     </>
//   );
// }


import { useEffect, useState, useMemo } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import api from "../../api/axiosInstance";

import { Helmet } from "react-helmet-async";

import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeSlug from "rehype-slug";
import rehypeAutolinkHeadings from "rehype-autolink-headings";
import rehypeHighlight from "rehype-highlight";

import NavigationTabBar from "../../components/navigation/NavigationTabBar";
import FooterSection from "../../components/navigation/FooterSection";

import "highlight.js/styles/github.css";

/* ================= Skeleton ================= */

const Skeleton = () => (
  <div className="max-w-3xl mx-auto pt-32 px-4 animate-pulse">
    <div className="h-10 bg-gray-200 rounded mb-6" />
    <div className="h-4 bg-gray-200 rounded w-1/3 mb-10" />
    <div className="h-[360px] bg-gray-200 rounded-xl mb-10" />
    <div className="space-y-4">
      <div className="h-4 bg-gray-200 rounded" />
      <div className="h-4 bg-gray-200 rounded" />
      <div className="h-4 bg-gray-200 rounded w-2/3" />
    </div>
  </div>
);

export default function BlogDetail() {

  const { slug } = useParams();
  const navigate = useNavigate();

  const [data, setData] = useState(null);
  const [relativeTime, setRelativeTime] = useState("");
  const [readingProgress, setReadingProgress] = useState(0);

  /* ================= Fetch Blog ================= */

  useEffect(() => {

    api.get(`/api/blogs/slug/${slug}`).then((res) => {

      setData(res.data.data);

    });

  }, [slug]);

  /* ================= Reading Progress ================= */

  useEffect(() => {

    const updateScrollProgress = () => {

      const totalHeight =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight;

      const scrollPosition = window.scrollY;

      const progress = (scrollPosition / totalHeight) * 100;

      setReadingProgress(progress);
    };

    window.addEventListener("scroll", updateScrollProgress);

    return () => window.removeEventListener("scroll", updateScrollProgress);

  }, []);

  /* ================= Relative Time ================= */

  const getRelativeTime = (dateString) => {

    const now = new Date();
    const past = new Date(dateString);

    const seconds = Math.floor((now - past) / 1000);

    const intervals = {
      year: 31536000,
      month: 2592000,
      day: 86400,
      hour: 3600,
      minute: 60,
    };

    for (let key in intervals) {

      const value = Math.floor(seconds / intervals[key]);

      if (value >= 1) {

        return value + " " + key + (value > 1 ? "s" : "") + " ago";

      }
    }

    return "Just now";
  };

  useEffect(() => {

    if (data?.blog?.publishedAt) {

      setRelativeTime(getRelativeTime(data.blog.publishedAt));

    }

  }, [data]);

  /* ================= TOC ================= */

  const headings = useMemo(() => {

    if (!data?.blog?.content) return [];

    const regex = /^(##|###)\s+(.*)$/gm;

    const items = [];
    let match;

    while ((match = regex.exec(data.blog.content)) !== null) {

      items.push({
        level: match[1].length,
        text: match[2],
        id: match[2].toLowerCase().replace(/[^\w]+/g, "-"),
      });

    }

    return items;

  }, [data]);

  if (!data) return <Skeleton />;

  const { blog, related = [] } = data;

  /* ================= Read Time ================= */

  const calculateReadTime = (content) => {

    if (!content) return "1 min read";

    const words = content.split(" ").length;

    const minutes = Math.ceil(words / 200);

    return `${minutes} min read`;

  };

  return (

    <>

      {/* ================= SEO ================= */}

      <Helmet>

        <title>{blog.title}</title>

        <meta name="description" content={blog.excerpt} />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BlogPosting",
            headline: blog.title,
            image: blog.coverImage,
            author: blog.author?.name,
            datePublished: blog.publishedAt
          })}
        </script>

      </Helmet>

      <NavigationTabBar />

      {/* ================= Reading Progress Bar ================= */}

      <div
        className="fixed top-0 left-0 h-1 bg-indigo-600 z-50"
        style={{ width: `${readingProgress}%` }}
      />

      <div className="min-h-screen bg-gray-50">

        {/* ================= Back Button ================= */}

        <div className="max-w-4xl mx-auto px-4 pt-24">

          <button
            onClick={() => navigate("/blog-content-hub")}
            className="text-gray-600 hover:text-gray-900"
          >
            ← Back to Blogs
          </button>

        </div>

        <div className="max-w-4xl mx-auto px-4 pb-32">

          {/* ================= TITLE ================= */}

          <h1 className="text-4xl font-bold text-center mt-8 mb-4">
            {blog.title}
          </h1>

          {/* ================= META ================= */}

          <div className="flex justify-center gap-4 text-gray-500 mb-8">

            <span>{relativeTime}</span>

            <span>•</span>

            <span>{blog.views || 0} views</span>

            <span>•</span>

            <span>{calculateReadTime(blog.content)}</span>

          </div>

          {/* ================= COVER IMAGE ================= */}

          {blog.coverImage && (

            <div className="mb-10">

              <img
                src={blog.coverImage}
                alt={blog.title}
                loading="lazy"
                className="rounded-xl w-full"
                style={{ aspectRatio: "16/9", objectFit: "cover" }}

                onError={(e) => {
                  e.target.src =
                    "https://images.unsplash.com/photo-1555949963-aa79dcee981c";
                }}

              />

            </div>

          )}

          {/* ================= BLOG CONTENT ================= */}

          <article
            className="prose prose-lg max-w-none
            prose-headings:font-bold
            prose-h2:text-3xl
            prose-h3:text-2xl
            prose-p:text-gray-700
            prose-img:rounded-xl
            prose-a:text-indigo-600"
          >

            <ReactMarkdown
              remarkPlugins={[remarkGfm]}
              rehypePlugins={[
                rehypeSlug,
                rehypeHighlight,
                [rehypeAutolinkHeadings, { behavior: "wrap" }],
              ]}
            >

              {blog.content}

            </ReactMarkdown>

          </article>

          {/* ================= RELATED ARTICLES ================= */}

          {related.length > 0 && (

            <section className="mt-20">

              <h3 className="text-2xl font-bold mb-6">
                Related Articles
              </h3>

              <div className="grid md:grid-cols-3 gap-6">

                {related.map((r) => (

                  <Link
                    key={r._id}
                    to={`/blog/${r.slug}`}
                    className="border rounded-xl overflow-hidden hover:shadow-lg"
                  >

                    <img
                      src={r.coverImage}
                      alt={r.title}
                      className="h-40 w-full object-cover"
                    />

                    <div className="p-4">

                      <h4 className="font-semibold mb-2">
                        {r.title}
                      </h4>

                      <p className="text-sm text-gray-600">
                        {r.excerpt}
                      </p>

                    </div>

                  </Link>

                ))}

              </div>

            </section>

          )}

        </div>

        {/* ================= TOC ================= */}

        {headings.length > 0 && (

          <aside className="hidden xl:block fixed right-8 top-32 w-64">

            <div className="bg-white rounded-lg shadow-md p-4">

              <h4 className="font-semibold mb-3">
                On this page
              </h4>

              <ul className="space-y-2 text-sm">

                {headings.map((h) => (

                  <li key={h.id} className={h.level === 3 ? "ml-4" : ""}>

                    <a
                      href={`#${h.id}`}
                      className="text-gray-600 hover:text-indigo-600"
                    >
                      {h.text}
                    </a>

                  </li>

                ))}

              </ul>

            </div>

          </aside>

        )}

      </div>

      <FooterSection />

    </>

  );
}